<template>
    <div :class="{ error: v$ && v$.value && v$.value[propname ?? name] && v$.value[propname ?? name].$errors.length }">
        <ckeditor :id="Id" :name="Id" ref="Editor" :config="editorConfig" :modelValue="modelValue"
            @input="updateValue($event.target.value)" @focus="updateValue(($event?.editor?.getData() ?? ''))"
            @blur="updateValue(($event?.editor?.getData() ?? ''))"></ckeditor>
    </div>
    <div v-if="v$ && v$.value && v$.value[propname ?? name]">
        <div class="input-errors" v-for="error of v$.value[propname ?? name].$errors" :key="error.$uid">
            <div class="error-msg">{{ error.$message }}</div>
        </div>
    </div>
</template>

<script setup>
import { useToast } from "primevue/usetoast";
import { defineProps, defineEmits, ref, inject, watch, onMounted, onUpdated, onBeforeMount } from "vue";
import { component as ckeditor } from '@mayasabha/ckeditor4-vue3'
const emit = defineEmits(["update:modelValue"]);
let Editor = ref()
let Props = defineProps({
    Id: { type: String, default: "editor", },
    modelValue: { type: String, required: true, default: "", },
    IsreadOnly: { type: Boolean, default: false },
    v$: Object,
    name: { type: String, required: true, },
    propname: { type: String, required: false, },
});
const editorConfig = ref({
    height: 200,
    allowedContent: true,
    resize_enabled: false,
    enterMode: 2, // CKEDITOR.ENTER_BR
    readOnly: Props.IsreadOnly,
    removeButtons: 'PasteFromWord',
    on: {
        change: function (evt) {
            updateValue((evt?.editor?.getData() ?? ''));
        },
    },
})
const updateValue = (value) => {
    if (value == null || value == "null") {
        value = "";
    }
    emit("update:modelValue", value);
};
watch(() => Props.modelValue, () => {
    updateValue(Props.modelValue);
});
</script>